import { useEffect, useRef, useState } from "react";
import Styles from "./subcomponents.module.css";
//Code component
export const Code        = ( props ) => {
    const { code, codeType, width, theme } = props;
    const { Code } = Styles;
    const copyText = ( text ) => {
        navigator.clipboard.writeText( text )
        .then(() => {
            alert("code copied to clipboard!");
        })
        .catch((error) => {
            alert("code faild to be copied to clipboard!!");
        });
    }
    return (
        <div className={ Code } style={{ maxWidth: width && `${ width }px`, color: theme ? theme : "white" }}>
            <div style={{  backgroundColor: theme ? theme : "white" }}></div>
            <header style={{ color: theme ? theme : "white" }}>
                <i className="bi bi-code-square"></i>
                <span style={{ backgroundColor: theme ? theme : "white" }}></span>
                <span>{ codeType ? codeType : "Code" }</span>
                <i className="bi bi-clipboard2-fill" onClick={_=> copyText( code )}></i>
            </header>
            <main>
                <pre><code>{ code }</code></pre>
            </main>
        </div>
    );
}; 
//native image component
export const Image       = ( props ) => {
    const { src, theme, link, width } = props;
    const { Image } = Styles;
    return (
        <div className={ Image } style={{ maxWidth: `${ width }px`, maxHeight: `${ width * 0.6}px`, color: !theme ? "white" : theme }}>
            <div style={{  backgroundColor: !theme ? "white" : theme }}></div>
            <a href={ link && link }></a>
            <img src={ src }/>
        </div>
    );
};
//special headlines component
export const Headline    = ( props ) => {
    const { icon, text, theme, width, link, subIcon } = props;
    const { Headline } = Styles;
    return (
        <div className={ Headline } style={{ color: !theme ? "white" : theme, maxWidth: width ? `${ width }px` : "auto" }}>
            <div style={{  backgroundColor: !theme ? "white" : theme }}></div>
            { icon && icon }
            <span></span>
            <h1><bdi>{ text }</bdi></h1>
            { subIcon && subIcon }
            <a href={ link && link }></a>
        </div>
    );
};
//special buttons component
export const Button      = ( props ) => {
    const { type, icon, text, width, height, theme, link , onClick } = props;
    const { Button } = Styles;
    return (
        <button className={ Button } type={ type } onClick={ e => onClick && onClick( e ) } style={{ color: theme ? theme : "white", width: width && `${ width }px`, height: height && `${ height }px` }}>
            <div style={{  backgroundColor: !theme ? "white" : theme }}></div>
            { icon }
            <span style={{  backgroundColor: !theme ? "white" : theme }}></span>
            <span>{ text }</span>
            <a href={ link && link }></a>
        </button>
    );
};
//special Header component
export const SubHeader   = ( props ) => {
    const { icon, text, link, } = props;
    const { SubHeader } = Styles;
    return (
        <header className={ SubHeader }>
            { icon }
            <span></span>
            <h1><bdi>{ text }</bdi></h1>
            <a href={ link && link }></a>
        </header>
    );
};
//special input component
export const Input       = ( props ) => {
    const { type, name, text, value, onChange, icon, width, height, theme, color } = props;
    const { Input } = Styles;
    const input = useRef(null);
    const clearInp = _=>{
        input.current.value = "";
    };
    return (
        <div className={ Input } style={{ width: width && `${ width }px`, height: height && `${ height }px`, color: theme ? theme : "white" }}>
            <div style={{ backgroundColor: theme ? theme : "white" }}></div>
            { icon }
            <span style={{ backgroundColor: color ? color : "white" }}></span>
            <input ref={ input } required type={ type ? type : "text" } name={ name } placeholder={ text ? text : "input" } value={ value && value } onChange={ e => onChange && onChange( e ) } style={{ color: color ? color : "white" }}/>
            <i className="bi bi-x-circle" onClick={ clearInp } style={{ color: color ? color : "white" }}></i>
        </div>
    );
};
//attributes component
export const Attribute   = ( props ) => {
    const { Attributes = [], width } = props;
    const { Attribute, Attr, spanAttr} = Styles;
    return (
        <div className={ Attribute } style={{ maxWidth: width && `${ width }px` }}>
            {
                Attributes.map(( value, key ) => {
                    const { icon, span, text, fontFamily, color, link, onClick } = value;
                    return (
                        <div className={ Attr } key={ key } onClick={ e => onClick && onClick( e )}>
                            { icon && icon }
                            { span && span }
                            <span className={ spanAttr } style={{ fontFamily: fontFamily && fontFamily, color: color && color }}><bdi>{ text && text}</bdi></span>
                            <a href={ link && link }></a>
                        </div>
                    );
                })
            }
        </div>
    );
};
//pro headline component
export const ProHeadline = ( props ) => {
    const { headlines = [] } = props;
    const { ProHeadline    } = Styles;
    const [ headline, setHealine ] = useState(null);
    useEffect(_=>{
        setHealine(headlines[ Math.floor(Math.random() * headlines.length) ]);
    }, []);
    return (
        <div className={ ProHeadline }>
            <h1><bdi>{ headline }</bdi></h1>
        </div>
    );
};
export const Caption     = ( props ) => {
    const { title, titleIcon, date, sections = [], width, theme, color } = props;
    const { Caption, Section } = Styles;
    return (
        <div className={ Caption } style={{ maxWidth: width && `${ width }px`, color: theme ? theme : "white"}}>
            <div style={{ backgroundColor: theme ? theme : "white" }} ></div>
            <header>
                <div>
                    {
                        titleIcon ? titleIcon :
                        <i className="bi bi-card-text" style={{ color: color ? color : "white" }}></i>
                    }
                    <span style={{ backgroundColor: color ? color : "white" }}></span>
                    <span style={{ color: color ? color : "white" }}>{ title ? title : "Caption" }</span>
                </div>
                <span style={{ color: color ? color : "white" }}>{ date }</span>
            </header>
            <main>
                {
                    sections.map(( value, key ) => {
                        const { title, text, code, codeType, codeTheme, image, imageTheme, headline, headlineIcon, headlineTheme, width } = value;
                        return (
                        <div className={ Section } style={{ color: color ? color : "white" }} key={ key }>
                            <h1><bdi>{ title }</bdi></h1>
                            <p><bdi>{ text }</bdi></p>
                            { code && <Code code={ code } codeType={ codeType } theme={ codeTheme } width={ width }/> }
                            { image && <Image src={ image } theme={ imageTheme } width={ width }/> }
                            { headline && <Headline icon={ headlineIcon } text={ headline }theme={ headlineTheme } width={ width }/> }
                        </div>);
                    })
                }
            </main>
        </div>
    );
};
//the video list and video components
export const VideoList   = ( props ) => {
    const { videos = [], title: { icon, text} = {}, currentVideo, width} = props;
    const { VideoList } = Styles;
    return (
        <div className={ VideoList } style={{ maxWidth: width && `${ width }px` }}>
            <SubHeader icon={ icon } text={ text }/>
            {
                videos.map(( value, key ) => {
                    const { id, image, text, duration, link, theme, substring } = value;
                    return (
                        <Video 
                            image     = { image     } 
                            text      = { text      } 
                            duration  = { duration  } 
                            link      = { link      } 
                            theme     = { theme     } 
                            substring = { substring }
                            opacity   = { currentVideo === id && "0.6" }
                            key       = { key       }
                        />
                    );
                })
            }
        </div>
    );
};
export const Video       = ( props ) => {
    const { image, text, duration, link, theme, substring, opacity } = props;
    const { Video, VideoImg, VideoInfo } = Styles;
    return (
        <div className={ Video } style={{ color: theme ? theme : "white" }}>
            <div style={{ backgroundColor: theme ? theme : "white", opacity: opacity && opacity }}></div>
            <div className={ VideoImg }><img src={ image && image }/></div>
            <div className={ VideoInfo }>
                <span><bdi>{ text.substring(0, substring) + "..." }</bdi></span>
                <div>
                    <SubHeader icon={ <i className="bi bi-clock-fill"></i> } text={ duration }/>
                    <i className="bi bi-play-circle-fill"></i>
                </div>
            </div>
            <a href={ link && link }></a>
        </div>
    );
};
//the content list component
export const ContentList = ( props ) => {
    const { warnings, width, title, titleIcon, cells = [] } = props;
    const { ContentList } = Styles;
    return (
        <div className={ ContentList } style={{ maxWidth: width && `${ width }px` }}>
            { warnings && <Warning warnings={ warnings } width={ width } theme={ "#f44336" }/> }
            <SubHeader 
                icon = { titleIcon ? titleIcon :<i className="b bi-cpu-fill"></i> } 
                text = { title ? title : "Different Versions"                     }
            />
            {
                cells.map(( value, key ) => {
                    const { isLock, name, date, size, files, link, theme, color } = value;
                    return (
                        <Cell 
                            isLock     = { isLock     }
                            name       = { name       }
                            date       = { date       }
                            size       = { size       }
                            files      = { files      }
                            link       = { link       }
                            theme      = { theme      }
                            color      = { color      }
                            width      = { width      }
                            key        = { key        }
                        />
                    );
                })
            }
        </div>
    );
};
//the cell component
export const Cell        = ( props ) => {
    const { isLock, name, date, size, files, link, width, theme, color } = props;
    const { Cell } = Styles;
    const Attributes1 = [
        { icon: <i className="bi bi-archive-fill"></i>,                                                                                                        span: <span></span>,                             text: files, fontFamily: "Sarabun"   },
        { icon: <i className="bi bi-file-earmark-fill"></i>,                                                                                                   span: <span></span>,                             text: size,  fontFamily: "Sarabun"   },
        { icon: <i className="bi bi-lock-fill"               style={{ color: "red", transform: "translateX(35px)", display: isLock ? "block" : "none" }}></i>, span: <span style={{ display: "none" }}></span>                                       },
        { icon: <i className="bi bi-share-fill"              style={{ color: "white", transform: "translateX(15px)" }}></i>,                                   span: <span style={{ display: "none" }}></span>                                       },
        { icon: <i className="bi bi-cloud-arrow-down-fill"   style={{ color: "green", fontSize: "25px" }}></i>,                                                span: <span style={{ display: "none" }}></span>                                       },
    ];
    return (
        <div className={ Cell } style={{ maxWidth: width && width, color: theme ? theme : "white" }}>
            <div style={{ backgroundColor: theme ? theme : "white" }}></div>
            <header style={{ color: color ? color : "white" }}>
                <div>
                    <i className="bi bi-tag-fill"></i>
                    <span style={{ backgroundColor: color ? color : "white" }}></span>
                    <h1><bdi>{ name }</bdi></h1>
                </div>
                <span>{ date }</span>
            </header>
            <main>
                <Attribute Attributes={ Attributes1 }/>
            </main>
        </div>
    ); 
};
//the warning component
export const Warning     = ( props ) => {
    const { warnings = [], width, theme, color, title } = props;
    const { Warnings, warning } = Styles;
    return (
        <div className={ Warnings } style={{ maxWidth: width && `${ width }px`, color: theme ? theme : "white" }}>
            <div style={{ backgroundColor: theme ? theme : "white" }}></div>
            <header style={{ color: color ? color : "white" }}>
                <i className="bi bi-exclamation-diamond-fill"></i>
                <span style={{ backgroundColor: color ? color : "white" }}></span>
                <span>{ title ? title : "Warning" }</span>
            </header>
            <main>
                {
                    warnings.map(( value, key ) => {
                        const { title, text, width, code, codeType, codeTheme, image, imageTheme, headline, headlineIcon, headlineTheme } = value;
                        return (
                        <div className={ warning } key={ key } style={{ color: color ? color : "white" }}>
                            <h1><bdi>{ title }</bdi></h1>
                            <p><bdi>{ text  }</bdi></p>
                            { code     && <Code     code = { code         } codeType = { codeType } width = { width      } theme = { codeTheme     }/> }
                            { image    && <Image    src  = { image        } width    = { width    } theme = { imageTheme }                          /> }
                            { headline && <Headline icon = { headlineIcon } text     = { headline } width = { width      } theme = { headlineTheme }/> }
                        </div>
                        );
                    })
                }
            </main>
        </div>
    );
};
//the video component